import React from 'react';
import styles from './app.module.css';
import headerImage from './assets/headerImage.jpg';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import gettingMarried from './assets/Getting Married Image.png';

import { Carousel } from 'react-responsive-carousel';
import { importImages } from './util';


function App() {
  const [images, setImages] = React.useState<any[]>([]);
  const [pets, setPets] = React.useState<any[]>([]);


  const imagesPromises = importImages(
    [
      "./assets/carousel/Carousel Image 1_1080x1080.jpg", 
      "./assets/carousel/Carousel Image 2_1080x1080.jpg", 
      "./assets/carousel/DSC01334 copy_1080x1080.jpg", 
      "./assets/carousel/DSC01802 copy_1080x1080.jpg", 
      "./assets/carousel/DSC01847 copy (1)_1080x1080.jpg", 
      "./assets/carousel/DSC02533 copy_1080x1080.jpg", 
      "./assets/carousel/IMG_0006_1080x1080.jpg", 
      "./assets/carousel/IMG_0596_1080x1080.jpg", 
      "./assets/carousel/IMG_1156_1080x1080.jpg", 
      "./assets/carousel/IMG_1210_1080x1080.jpg", 
      "./assets/carousel/IMG_1400_1080x1080.jpg", 
      "./assets/carousel/IMG_2141_1080x1080.jpg", 
      "./assets/carousel/IMG_2439_1080x1080.jpg", 
      "./assets/carousel/IMG_2838_1080x1080.jpg", 
      "./assets/carousel/IMG_3387_1080x1080.jpg", 
      "./assets/carousel/IMG_3952_1080x1080.jpg", 
      "./assets/carousel/IMG_3966_1080x1080.jpg", 
      "./assets/carousel/IMG_3986_1080x1080.jpg", 
      "./assets/carousel/IMG_4497_1080x1080.jpg", 
      "./assets/carousel/IMG_5501_1080x1080.jpg", 
      "./assets/carousel/IMG_5568_1080x1080.jpg", 
      "./assets/carousel/IMG_5909_1080x1080.jpg", 
      "./assets/carousel/IMG_5924_1080x1080.jpg", 
      "./assets/carousel/IMG_6034_1080x1080.jpg", 
      "./assets/carousel/IMG_6185_1080x1080.jpg", 
      "./assets/carousel/IMG_9921_1080x1080.jpg",
    ]
  );

  if (images.length == 0) {
    Promise.all(imagesPromises).then((images) => {
      setImages(images.map(img => img.default));
    });
  }

  const petsPromise = importImages(
    [
      "./assets/pets/88DA1525-28C3-4935-BF7A-B77297E4D4C7.jpg", 
      "./assets/pets/IMG_0788.jpg", 
      "./assets/pets/IMG_2538.jpg", 
      "./assets/pets/IMG_2614.jpg", 
      "./assets/pets/IMG_2677.jpg", 
      "./assets/pets/IMG_3018.jpg", 
      "./assets/pets/IMG_3083.jpg", 
      "./assets/pets/IMG_4971.jpg", 
      "./assets/pets/IMG_4990.jpg", 
      "./assets/pets/Miss Marble 2.jpg", 
      "./assets/pets/Miss Marble.jpg",
    ]
  );

  if (pets.length == 0) {
    Promise.all(petsPromise).then((images) => {
      setPets(images.map(img => img.default));
    });
  }

  return (
    <div className={styles.app}>
      <div className={styles.container}>
        <div className={styles.titleContainer}>
          <div className={styles.titleWords}>
            <img className={styles.gettingMarried} src={gettingMarried}/>
          </div>
          <img className={styles.headerImage} src={headerImage} />
        </div>

        <div className={styles.text1}>
          Following their intimate Colorado elopement, Matthew and Destiny warmly invite you to join them for a reception in celebration of their marriage.
        </div>
        <div className={styles.location}>
          <div className={styles.bold}>February 20 2027</div>
          <div>The Parthenon</div>
          <div>Nashville, TN</div>
          <div className={styles.bold}>6:30 - 10</div>
        </div>
        <div className={styles.detailsContainer}>
          <div className={styles.detailsSubcontainer}>
            <div className={styles.detailsTitle} >
              Details:
            </div>
            <div className={styles.detailsSubtitle}>No Gifts</div>
            
            We are so happy to have you join us to celebrate our love and marriage.
            Your company is the only gift we need! Please do not bring any gifts, please do not attempt to give us any money.
            Our lives are abundant and we only wish to celebrate with our loved ones!
            If you feel you MUST contribute, please feel free to make a contribution to a cause that we support, such as the ACLU or symbolically adopt an animal species through the World Wildlife Fund.

            <div style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '20px',
            }}>
              <a className={styles.button} href='https://www.aclu.org/'>
                ACLU
              </a>

              <a className={styles.button} href='https://gifts.worldwildlife.org/gift-center/gifts/Species-Adoptions?sort=2'>
                Wildlife Fund
              </a>
            </div>
            
            <div className={styles.detailsSubtitle}>No Kids :(</div>

            <div>
              We love all the little ones in our lives!
              However, the venue and vibes of this event are not kid friendly.
              Please join us for this adult-only reception! 
            </div>
            
            <div className={styles.detailsSubtitle}>Suggested Attire: Formal</div>
          </div>

          <div className={styles.rsvp}>
            RSVP
          </div>

          Please use this form to RSVP at your earliest convenience.

          <a className={styles.button} href="https://docs.google.com/forms/d/e/1FAIpQLScpxSxb704jkSrkvLiVB5hNFhSYSFZ-fxjg49TM2ZJzXQ4Guw/viewform?usp=header">
              RSVP HERE
            </a>
        </div>

        <div className={styles.carouselContainer}>
          <Carousel
            showStatus={false}
            showThumbs={false}
            centerMode={true}
            interval={1}
            showIndicators={false}
            infiniteLoop={true}
          >
            {images.map((image) => { 
              return (
              <div style={{height: '100%', margin: '0px 16px'}}>
                <img 
                  style={{position: 'relative',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    
                  }} src={image} />
              </div>
            );
            })}
          </Carousel>
        </div>


          <div className={styles.detailsTitle}>
            Our Story 
          </div>



          <div className={styles.detailsSubcontainer2}>
            After spending four years living just two miles apart without ever meeting, Matthew and Destiny finally crossed paths in Boulder, Colorado, in 2023. They quickly bonded over their shared roots, love of reading and animals, and vegetarian lifestyle. They spent a beautiful summer in Boulder getting to know one another and falling in love.          </div>

          <div className={styles.detailsSubcontainer2}>
            Since then, they've enjoyed countless adventures across Colorado and around the world. On September 23, 2025, Matthew proposed to Destiny in Pescia Romana, Italy. Today, they live in Fort Collins, Colorado, with their other two loves: Sparkles and the newest member of the family, March.
          </div>

          <div style={{marginTop: '8px'}} />


          <div className={styles.detailsContainer}>

            <div className={styles.detailsTitle2}>
              Sparkles
            </div>

            <div className={styles.detailsSubcontainer3}>
              Destiny "adopted" Sparkles from a trash can in 2020, and she has been her ever-present sidekick ever since. After many years as a girl-gang duo, Sparkles graciously welcomed Matthew into the fold. She now serves in her rightful role as Queen of the Household, overseeing all activities from her throne. All hail Queen Sparkles.
            </div>

            
            <div className={styles.detailsTitle2}>
              March
            </div>

            <div className={styles.detailsSubcontainer3}>
              March, Marchy, Marching Girl is the newest member of the family. Matthew and Destiny adopted March, a retired racer and mommy into the family this spring. After a rough life she has joined her new family for a life of treats, naps, and snuggles. And to be an additional loyal delegate to the Queen. 
            </div>

            <div className={styles.carouselContainer}>
              <Carousel
                showStatus={false}
                showThumbs={false}
                showIndicators={false}
                centerMode={true}
                infiniteLoop={true}
              >
                {pets.map((image) => { 
                  return (
                    <div style={{height: '100%', margin: '0px 16px'}}>
                      <img 
                        style={{position: 'relative',
                          top: '50%',
                          transform: 'translateY(-50%)'
                        }} src={image} />
                  </div>
                );
                })}
            </Carousel>
          </div>
        </div>
        <div style={{marginTop: '8px'}} />
          <div style={{width: '100%', height: 'auto'}}>
            <iframe width="100%" height="400px" src="https://drive.google.com/file/d/1BMBL6Dnhn2KpRQqg02maxHm9RR7HKMmu/preview"></iframe>
          </div>
      </div>
    </div>
  );
}

export default App;
